<div (click)="onContainerClicked($event)"
     class="modal fade"
     tabindex="-1"
     [ngClass]="{'in': visibleAnimate}"
     [ngStyle]="{'display': visible ? 'block' : 'none', 'opacity': visibleAnimate ? 1 : 0}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        User Info
      </div>
      <div class="modal-body">
        <div class="widget-inner-title">Username:</div>
        <div class="widget-inner-content">{{ownerUname}}</div>
        <div class="widget-inner-title">Affiliation:</div>
        <div class="widget-inner-content">{{ownerAffiliation}}</div>
        <div class="widget-inner-title">First Name:</div>
        <div class="widget-inner-content">{{ownerFname}}</div>
        <div class="widget-inner-title">Last Name:</div>
        <div class="widget-inner-content">{{ownerLname}}</div>
        <div class="widget-inner-title">Email:</div>
        <div class="widget-inner-content">{{ownerEmail}}</div>
      </div>
      <div class="modal-footer">

        <!--Impersonate button-->
        <!--<button type="button"-->
                <!--class="btn btn-default impersonate-btn custom-btn transition">-->
          <!--Impersonate-->
        <!--</button>-->

        <button type="button"
                class="btn btn-primary custom-btn transition"
                (click)='hide()'>
          Done
        </button>
      </div>
    </div>
  </div>
</div>
